import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useSeo } from "@/lib/seo";

const JOIN_ALTERNATES = [
  { hreflang: "en", path: "/join" },
  { hreflang: "hi", path: "/hi/join" },
  { hreflang: "x-default", path: "/join" },
];

export default function HiJoin() {
  useSeo({
    title: "टेस्टर बनें — अपने फ़ोन पर ऐप टेस्ट करके कमाएँ",
    description: "अपने फ़ोन या लैपटॉप पर 45 मिनट के पेड टेस्टिंग सेशन। हर सेशन ₹300 और असली बग के लिए बोनस, सीधे UPI पर। भारत भर के 20,000 टेस्टर्स से जुड़ें।",
    path: "/hi/join",
    lang: "hi",
    alternates: JOIN_ALTERNATES,
  });
  const [form, setForm] = useState({ name: "", city: "", email: "" });
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await api.join(form);
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "कुछ गड़बड़ हो गई। फिर से कोशिश करें।");
    } finally {
      setBusy(false);
    }
  }

  if (sent) {
    return (
      <main className="app-main"><div className="wrap narrow" data-testid="join-confirm">
        <span className="pill">लिंक भेज दिया</span>
        <h1 style={{ marginTop: 12 }}>अपना ईमेल देखें।</h1>
        <p className="lede">हमने <b>{form.email}</b> पर एक्टिवेशन लिंक भेजा है। इसे खोलकर अपने डिवाइस और UPI ID कन्फ़र्म करें, फिर आपको सेशन ऑफ़र मिलने लगेंगे।</p>
        <p className="muted small">नहीं मिला? स्पैम देखें, या <button type="button" className="btn ghost sm" onClick={() => setSent(false)}>फिर से कोशिश करें</button>।</p>
      </div></main>
    );
  }

  return (
    <main className="app-main"><div className="wrap narrow">
      <div className="muted small" style={{ marginBottom: 8 }}><Link to="/join" data-testid="lang-en">English</Link> · <b>हिंदी</b></div>
      <span className="pill neutral">ऐप टेस्ट करके कमाएँ</span>
      <h1 style={{ marginTop: 12 }}>99tests टेस्टर बनें।</h1>
      <p className="lede">अपने फ़ोन या लैपटॉप पर छोटे, पेड टेस्टिंग सेशन चलाएँ — हर 45-मिनट सेशन के ₹300, और असली बग के लिए बोनस, सीधे आपके UPI पर।</p>
      <div className="panel-soft" style={{ padding: "18px 20px", marginTop: 16 }}>
        <h4 style={{ marginBottom: 8 }}>यह कैसे काम करता है</h4>
        <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.7, fontSize: 15 }}>
          <li>जब कोई सेशन आपके डिवाइस से मैच करता है, हम आपको ईमेल करते हैं।</li>
          <li>45 या 90 मिनट, तय फ़ीस — चाहे बग मिलें या न मिलें।</li>
          <li>हर असली, दोबारा दिखाए जा सकने वाले बग पर ₹100–₹500 बोनस।</li>
          <li>क्लाइंट की रिपोर्ट जाने के बाद आपके UPI पर भुगतान।</li>
        </ul>
      </div>
      <form className="panel-soft" style={{ padding: 26, marginTop: 16 }} onSubmit={submit} data-testid="join-form">
        {error && <p className="err" style={{ color: "var(--fail)", fontWeight: 500 }} data-testid="join-error">{error}</p>}
        <div className="row">
          <div className="field"><label htmlFor="name">नाम</label><input id="name" data-testid="join-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="field"><label htmlFor="city">शहर</label><input id="city" data-testid="join-city" value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} /></div>
        </div>
        <div className="field"><label htmlFor="email">ईमेल</label><input type="email" id="email" data-testid="join-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /><p className="hint">डिवाइस और UPI ID कन्फ़र्म करने के लिए हम एक लिंक भेजेंगे।</p></div>
        <button className="btn green block" type="submit" disabled={busy} data-testid="join-submit">{busy ? "भेज रहे हैं…" : "मुझे एक्टिवेशन लिंक भेजें"}</button>
      </form>
      <p className="muted small" style={{ marginTop: 16 }}>जुड़ने पर, एक्टिवेट करते समय आप <Link to="/tester-terms">टेस्टर शर्तें</Link> स्वीकार करेंगे।</p>
    </div></main>
  );
}
